import { render, staticRenderFns } from "./IpAttributes.vue?vue&type=template&id=7abdeb90&"
import script from "./IpAttributes.vue?vue&type=script&lang=js&"
export * from "./IpAttributes.vue?vue&type=script&lang=js&"
import style0 from "./IpAttributes.vue?vue&type=style&index=0&id=7abdeb90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports